export default {
    ChannelThirdPartyPlatform: {
      Add: 'Add',
      Account: 'Account',
      code: 'Account code',
      API: 'API address',
      app_Key: 'app_Key',
      appSecret: 'app Secret',
      name: 'Platform application name',
      type: 'Platform application type',
      Authorizable: 'Authorizable account',
      address: 'Platform authorization address',
      Number: 'Collaboration Number',
      Callback: 'Callback address',
      traffic: 'Certificate traffic',
      Channel: 'Channel code',
      Creator: 'Created By',
      Creation: 'Creation date',
      Currency: 'Currency',
      Delete: 'Delete status',
      Last: 'Last update date',
      by: 'Last updated by',
      Other: 'Other address',
      Development: 'Development platform address',
      Project: 'Project',
      Remarks: 'Remarks',
      Status: 'Status',
      System: 'System ID',
      Tax: 'Tax ID',
      Normal: 'Normal',
      Exception: 'Exception',
      third: 'Add a third-party platform',
    }
};
